import { Pipe, PipeTransform } from '@angular/core';
import { ND } from '@pt/pt-models';


@Pipe({
  name: 'formatNewlineToHtml',
  pure: false
})

export class FormatNewlineToHtmlPipe implements PipeTransform {

  transform(value: string): string {
    if (typeof value === 'undefined' || value === 'null' || value === null || value === undefined) {
      return ND;
    } else {
      return value.replace(/\n/g, '<br>');
    }
  }
}
